import type { CartConfig } from '#root/types/config/pages/cart'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    header: 'b-grey-50 mb-4 lg:mb-6',
    headerContent: 'lg:w-2/3 md:(w-7/12 pr-12)',
    headerDivider: 'mx-2',
    headerTotalItems: 'flex items-center justify-end <md:text-sm',
    items: 'pb-0 md:pb-12',
    itemsPerShipping: 'b-grey-50',
    noItems: 'mx-a py-16 md:py-20 -mt-4 lg:-mt-6 text-center title-2'
  },
  coupon: {
    brandClasses: {
      formError: 'mt-1',
      pillsWrapper: 'flex wrap mt-2 gap-2',
      pillsTitle: 'text-xs'
    },
    buttonVariant: 'secondary'
  },
  item: {
    actionMenu: {
      brandClasses: {
        button: 'px-4 py-3 gap-3',
        list: 'divide-grey-50'
      },
      dialogOptions: { type: 'panel' },
      iconSize: 'md'
    },
  },
  outOfStock: {
    dialogOptions: { type: 'panel' },
    showHeader: true,
    showPrice: true,
    showRemoveAll: true,
    showRemoveItem: true,
    showSaveForLater: true
  },
  quickshop: {
    dialogOptions: {
      type: {
        sm: 'panel',
        md: 'modal'
      },
      position: 'bottom'
    }
  },
  savedForLater: {
    addToCartButtonVariant: 'secondary',
    dialogOptions: { type: 'panel' },
    moveToCartIcon: 'bag',
    savedForLaterPageSize: 6
  },
  showTotalInHeader: true
} satisfies RecursivePartial<CartConfig>
